import { render, staticRenderFns } from "./c_slider.vue?vue&type=template&id=1695060e&scoped=true"
import script from "./c_slider.vue?vue&type=script&lang=js"
export * from "./c_slider.vue?vue&type=script&lang=js"
import style0 from "./c_slider.vue?vue&type=style&index=0&id=1695060e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1695060e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1695060e')) {
      api.createRecord('1695060e', component.options)
    } else {
      api.reload('1695060e', component.options)
    }
    module.hot.accept("./c_slider.vue?vue&type=template&id=1695060e&scoped=true", function () {
      api.rerender('1695060e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_slider.vue"
export default component.exports